import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "../../../../components/Shared/Loader/Loader";
import { utilService } from "../../../../services";
import { aboutParams, RespAboutInterface } from "./About.model";
import "./About.scss";
import { AboutService } from "./About.service";

interface AboutProps {
  onCancel: () => void;
}

const About: React.FC<AboutProps> = (props) => {
  const { t } = useTranslation("about");
  const [isLoaderActive, setLoaderStatus] = useState(true);
  var [aboutData, setAboutData]: any = useState([]);
  const [isLargeSCreen, setIsLargeScreen]: any = useState(true);

  useEffect(() => {
    getAboutDetailsToDisplay(params);
    checkIfLargeScreen();
  }, []);

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "large") {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }
  };

  async function getAboutDetailsToDisplay(params: aboutParams) {
    setLoaderStatus(true);
    const respAboutResult: RespAboutInterface =
      await AboutService.getAboutDetails(params);
    if (respAboutResult.isSuccess) {
      setAboutData(respAboutResult.displayAboutContainer[0]);
      console.log(respAboutResult.displayAboutContainer[0]);
    } else {
      console.log("error");
      AboutService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const onLinkClick = (link: any) => {
    window.open(link, "_blank");
  };

  const getAppVersion = () => { };

  const params = {
    reg_code: utilService.getNetwork(),
  };

  return (
    <div className="about-container">
      <div className="callcentral-logo-container">
        <div className="about-back" onClick={props.onCancel}>
          <div className="about-back-icon icon-back"></div>
          <div className="about-back-header">{t("aboutUs")}</div>
        </div>
        <div className="logo-wrapper">
          <img
            className="callcentral-logo"
            src="assets/icon/logoIcon.svg"
            alt="Nserix"
          />
          
        </div>
      </div>
      <div className="container-wrapper-div">
        {isLoaderActive && (
          <div className="loader-container">
            <Loader></Loader>
          </div>
        )}
        <div>
          <div className="content-header">{t("aboutSoftware")}</div>
          <div className="content-container">
            <div className="content-wrapper">
              <span className="title-label">{t("version")}</span>
              <span className="data-value">
                : {aboutData?.aboutSoftware?.customerAppVersion}
              </span>
            </div>
            <div className="content-wrapper">
              <span className="title-label">{t("releaseYear")}</span>
              <span className="data-value">
                : {aboutData?.aboutSoftware?.releaseYear}
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="content-header">{t("customerSupport")}</div>
          <div className="content-container">
            <div className="content-wrapper">
              <span className="title-label">{t("email")}</span>
              <span className="data-value">: {aboutData?.customer?.mail}</span>
            </div>
            <div className="content-wrapper">
              <span className="title-label">{t("contact")}</span>
              <span className="data-value">: {aboutData?.customer?.phone}</span>
            </div>
            <div className="content-wrapper">
              <span className="title-label">{t("website")}</span>
              <span
                className="data-value clickable-link"
                onClick={() => onLinkClick(aboutData?.customer?.website)}
              >
                : {t("websiteUrl")}
              </span>
            </div>
            <div className="content-wrapper">
              <span className="title-label">{t("playstore")}</span>
              <span
                className="data-value clickable-link"
                onClick={() => onLinkClick(aboutData?.customer?.playstore)}
              >
                : {t("callCentralAndroid")}
              </span>
            </div>
            <div className="content-wrapper">
              <span className="title-label">{t("appstore")}</span>
              <span
                className="data-value clickable-link"
                onClick={() => onLinkClick(aboutData?.customer?.appstore)}
              >
                : {t("callCentralIos")}
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="content-header">{t("aboutCompany")}</div>
          <div
            className={`content-container about-company ${isLargeSCreen && "about-company-large-screen"
              }`}
          >
            <div className="content-wrapper">{aboutData.aboutCompany}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
